import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const ImportIcon = ({ color = '#9BA8AC', size = 24, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.75 13.5C0.3375 13.5 0 13.8375 0 14.25V15.75C0 16.1625 0.3375 16.5 0.75 16.5H6V13.5H0.75ZM23.6719 4.92188L19.0828 0.328125C18.8719 0.117188 18.5859 0 18.2859 0H18V6H24V5.71406C24 5.41875 23.8828 5.13281 23.6719 4.92188ZM16.5 6.375V0H7.125C6.50156 0 6 0.501562 6 1.125V13.5H12V10.4438C12 9.77344 12.8109 9.44063 13.2844 9.91406L17.7656 14.4375C18.075 14.7516 18.075 15.2531 17.7656 15.5625L13.2797 20.0812C12.8062 20.5547 11.9953 20.2219 11.9953 19.5516V16.5H6V22.875C6 23.4984 6.50156 24 7.125 24H22.875C23.4984 24 24 23.4984 24 22.875V7.5H17.625C17.0063 7.5 16.5 6.99375 16.5 6.375Z"
      fill={color}
    />
    <path
      d="M16.5 6.375V0H7.125C6.50156 0 6 0.501562 6 1.125V13.5H12V10.4438C12 9.77344 12.8109 9.44063 13.2844 9.91406L17.7656 14.4375C18.075 14.7516 18.075 15.2531 17.7656 15.5625L13.2797 20.0812C12.8062 20.5547 11.9953 20.2219 11.9953 19.5516V16.5H6V22.875C6 23.4984 6.50156 24 7.125 24H22.875C23.4984 24 24 23.4984 24 22.875V7.5H17.625C17.0063 7.5 16.5 6.99375 16.5 6.375Z"
      fill={color}
    />
  </svg>
);

ImportIcon.propTypes = propTypes;

export default ImportIcon;
